import React from "react"

function IconShoppingCart({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="shopping-cart"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-shopping-cart"
      {...props}
    >
      <path
        d="M9.5 16.1a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2zm5.7 0a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2zm-5.7 1.2a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8zm5.7 0a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8zM4.489 3.875A1.6 1.6 0 0 1 5.993 4.93l.043.138.436 1.659h11c.09 0 .178.008.266.023l.13.027a1.6 1.6 0 0 1 1.184 1.804l-.03.143-1.458 5.702a1.6 1.6 0 0 1-1.406 1.197l-.145.007H8.804A1.6 1.6 0 0 1 7.3 14.573l-.043-.138-2.381-9.063a.4.4 0 0 0-.311-.29l-.076-.008H2.92a.6.6 0 0 1-.097-1.192l.097-.008h1.569zm12.983 4.052H6.787l1.63 6.204a.4.4 0 0 0 .311.291l.076.007h7.21a.4.4 0 0 0 .361-.228l.026-.072 1.459-5.703a.4.4 0 0 0-.289-.486l-.049-.01-.05-.003z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconShoppingCart
